import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import { parseStrapiContent } from "@lib/strapi/content";

export interface StrapiRelatedSectionDTO extends StrapiDynamicZoneComponentDTO {
  heading: string;
  direction: "TreatmentsForCondition" | "ConditionsForTreatment";
}

export class RelatedSectionDTO extends DynamicZoneComponentDTO {
  constructor() {
    super();
  }

  heading: string;
  direction: "TreatmentsForCondition" | "ConditionsForTreatment";
}
